function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 4.83333C10.3332 6.67428 8.84079 8.16667 6.99984 8.16667C5.15889 8.16667 3.6665 6.67428 3.6665 4.83333C3.6665 2.99238 5.15889 1.5 6.99984 1.5C8.84079 1.5 10.3332 2.99238 10.3332 4.83333Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 10.6667C3.77818 10.6667 1.1665 13.2783 1.1665 16.5H12.8332C12.8332 13.2783 10.2215 10.6667 6.99984 10.6667Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAvatar);
export default __webpack_public_path__ + "static/media/chat-avatar.19d7f140f1a8a5840300ab533d09e5cb.svg";
export { ForwardRef as ReactComponent };